import { Capacitor } from '@capacitor/core';

const isIOS = () => {
  return Capacitor.getPlatform() === 'ios';
};

export {
  isIOS,
};
